import SendIcon from '@mui/icons-material/Send';
import { Drawer } from 'components';

import * as S from '../Drawer.styled';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ShareDrawer = ({ isOpen, onClose }: IProps) => (
  <Drawer
    isOpen={isOpen}
    width={250}
    onClose={() => {
      onClose();
    }}
  >
    <S.Content>
      <S.Title variant="h5">Share results</S.Title>
      <S.Button endIcon={<SendIcon />}>share</S.Button>
    </S.Content>
  </Drawer>
);
